import React, { useState } from 'react';

interface ResetPasswordRequestProps {
  onSuccess: (email: string) => void;
  onCancel: () => void;
}

const ResetPasswordRequest: React.FC<ResetPasswordRequestProps> = ({ onSuccess, onCancel }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const API_URL = process.env.REACT_APP_API_URL || 
        'https://fieldvision-api.politemushroom-acd865dd.northeurope.azurecontainerapps.io';

      const response = await fetch(`${API_URL}/api/auth/reset-password/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Kunne ikke sende nulstillingskode');
      }

      onSuccess(email);
    } catch (err: any) {
      setError(err.message || 'Der opstod en fejl');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-8 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-2 text-center text-gray-800">Nulstil adgangskode</h2>
      <p className="text-sm text-gray-600 mb-6 text-center">
        Indtast din email, så sender vi dig en nulstillingskode
      </p>
      
      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="din@email.dk"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            required
          />
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors mb-3"
        >
          {loading ? 'Sender...' : 'Send nulstillingskode'}
        </button>

        <button
          type="button"
          onClick={onCancel}
          className="w-full py-3 bg-gray-100 text-gray-700 font-semibold rounded-lg hover:bg-gray-200 transition-colors"
        >
          Annuller
        </button>
      </form>
    </div>
  );
};

export default ResetPasswordRequest;
